import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Plus, Globe2, Users } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import api from '../utils/api';
import BottomNav from '../components/BottomNav';

const OrbitList = () => {
  const navigate = useNavigate();
  const { language } = useLanguage();
  const [orbits, setOrbits] = useState([]);

  const c = language === 'tr' ? {
    title: 'Orbit',
    subtitle: 'Grup Proje Takipçisi',
    noOrbits: 'Henüz Orbit yok',
    noOrbitsDesc: 'İlk Orbit\'inizi oluşturun.',
    createOrbit: 'Orbit Oluştur',
    joinOrbit: 'Katıl',
  } : {
    title: 'Orbit',
    subtitle: 'Group Project Tracker',
    noOrbits: 'No Orbits yet',
    noOrbitsDesc: 'Create your first Orbit.',
    createOrbit: 'Create Orbit',
    joinOrbit: 'Join',
  };

  useEffect(() => {
    const token = localStorage.getItem('auth_token');
    if (token) {
      api.get('/orbit/my-orbits')
        .then(res => setOrbits(res.data.orbits || []))
        .catch(() => setOrbits([]));
    }
  }, []);

  // Scroll to top on mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen pb-32 px-4 pt-12" style={{ position: 'relative', zIndex: 1 }}>
      <div className="max-w-lg mx-auto">
        
        {/* Header */}
        <div className="text-center mb-8" data-testid="orbit-header">
          <Globe2 className="w-12 h-12 text-[#D4AF37] mx-auto mb-3" />
          <h1 className="text-3xl font-bold text-white">{c.title}</h1>
          <p className="text-gray-400 text-base mt-1">{c.subtitle}</p>
        </div>

        {/* Action Buttons */}
        <div className="flex gap-3 mb-8" data-testid="orbit-buttons">
          <button
            onClick={() => navigate('/orbit/create')}
            className="flex-1 py-4 bg-[#D4AF37] text-black font-bold rounded-xl flex items-center justify-center gap-2 text-lg"
            data-testid="create-orbit-btn"
          >
            <Plus className="w-6 h-6" />
            {c.createOrbit}
          </button>
          <button
            onClick={() => {
              const code = prompt('Enter invite code:');
              if (code) navigate(`/orbit/join/${code}`);
            }}
            className="flex-1 py-4 border-2 border-[#D4AF37] text-[#D4AF37] font-bold rounded-xl flex items-center justify-center gap-2 text-lg"
            data-testid="join-orbit-btn"
          >
            <Users className="w-6 h-6" />
            {c.joinOrbit}
          </button>
        </div>

        {/* Orbits List */}
        {orbits.length === 0 ? (
          <div className="glass-panel rounded-xl p-8 text-center" data-testid="empty-state">
            <Globe2 className="w-16 h-16 text-[#D4AF37]/30 mx-auto mb-4" />
            <h3 className="text-white text-xl mb-2">{c.noOrbits}</h3>
            <p className="text-gray-400">{c.noOrbitsDesc}</p>
          </div>
        ) : (
          <div data-testid="orbits-list">
            {orbits.map((orbit) => (
              <div
                key={orbit.orbit_id}
                onClick={() => navigate(`/orbit/${orbit.orbit_id}`)}
                className="glass-panel rounded-xl p-5 mb-4 cursor-pointer hover:border-[#D4AF37]/50 transition-colors"
                data-testid={`orbit-card-${orbit.orbit_id}`}
              >
                <h3 className="text-white text-lg font-medium">{orbit.project_name}</h3>
                <p className="text-gray-400">{orbit.project_type}</p>
              </div>
            ))}
          </div>
        )}

      </div>
      <BottomNav />
    </div>
  );
};

export default OrbitList;
